import LampiranIV from './LampiranIV';

export default LampiranIV